import moment from "moment";
export const getCurrentDateTime = (onlyDate = false) => {
  if (onlyDate === true) {
    return moment(new Date()).format("YYYY-MM-DD");
  }
  return moment(new Date()).format("YYYY-MM-DD H:m:s");
};
export const formatDate = (dateTime, format = "YYYY-MM-DD H:m:s") => {
  return moment(dateTime).format(format);
};

export const getDateViewForamt = (date) => {
  return moment(date).format("DD-MMM-YYYY");
};

export const getDateTimeView = (date) => {
  return moment(date).format("DD-MMM-YYYY | hh:mm A");
};

export function formatDateText(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // 0-indexed
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function getDateModeFormat(mode, fromDate, toDate) {
  let date = "All";
  if (mode == "DAILY") {
    date = moment(fromDate).format("DD-MMM-YYYY");
  } else if (mode == "WEEKLY" || mode == "CUSTOM") {
    date = `${moment(fromDate).format("DD-MMM-YYYY")} To ${moment(
      toDate,
    ).format("DD-MMM-YYYY")}`;
  } else if (mode == "MONTHLY") {
    date = moment(fromDate).format("MMM YYYY");
  } else if (mode == "YEARLY") {
    date = moment(fromDate).format("YYYY");
  }
  return date;
}

export function getWeekFirstDate(date) {
  const firstDayOfWeek = parseLocalDate(date);
  const dayOfWeek = firstDayOfWeek.getDay();
  firstDayOfWeek.setDate(firstDayOfWeek.getDate() - dayOfWeek);
  return formatDateText(firstDayOfWeek);
}

export function getWeekLastDate(date) {
  const firstDayOfWeek = parseLocalDate(date);
  let dayOfWeek = firstDayOfWeek.getDay();
  firstDayOfWeek.setDate(firstDayOfWeek.getDate() - dayOfWeek);
  const lastDayOfWeek = parseLocalDate(firstDayOfWeek);
  lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);
  return formatDateText(lastDayOfWeek);
}

export function getMonthFirstDate(date) {
  const parsed = parseLocalDate(date);
  let year = parsed.getFullYear();
  let month = parsed.getMonth();
  let toDate = new Date(year, month, 1);
  let lastDate = formatDateText(toDate);
  return lastDate;
}

export function getMonthLastDate(date) {
  const parsed = parseLocalDate(date);
  let year = parsed.getFullYear();
  let month = parsed.getMonth();
  let totalDays = new Date(year, month + 1, 0).getDate();
  let toDate = new Date(year, month, totalDays);
  let lastDate = formatDateText(toDate);
  return lastDate;
}

export function getYearFirstDate(date) {
  const parsed = parseLocalDate(date);
  let year = parsed.getFullYear();
  let toDate = new Date(year, 0, 1);
  let startDate = formatDateText(toDate);
  return startDate;
}

export function getYearLastDate(date) {
  const parsed = parseLocalDate(date);
  let year = parsed.getFullYear();
  let toDate = new Date(year, 11, 31);
  let lastDate = formatDateText(toDate);
  return lastDate;
}

export function isDayEnabled(date, maxDate = "") {
  const selectedDate = moment(parseLocalDate(date));
  const currentDate = maxDate ? moment(parseLocalDate(maxDate)) : moment();
  return selectedDate.isSameOrBefore(currentDate, "day");
}

export function isYearEnabled(year) {
  let currentYear = new Date().getFullYear();
  return year < currentYear;
}

export function getCurrentYear(date) {
  let currentYear = new Date().getFullYear();
  if (date) {
    currentYear = parseLocalDate(date).getFullYear();
  }
  return currentYear;
}

export function getCurrentMonth(date) {
  let currentMonth = new Date().getMonth();
  if (date) {
    currentMonth = parseLocalDate(date).getMonth();
  }
  return currentMonth;
}

export function isMonthEnabled(month) {
  let currentMonth = new Date().getMonth();
  return month - 1 < currentMonth;
}

export function isDateBetween(fromDate, toDate, date) {
  var selectedFromDate = moment(parseLocalDate(fromDate));
  var selectedToDate = moment(parseLocalDate(toDate));
  var currentDate = moment(parseLocalDate(date));
  return (
    selectedToDate.isSameOrAfter(currentDate, "day") &&
    selectedFromDate.isSameOrBefore(currentDate, "day")
  );
}

export function getPreviousDate(date) {
  const fromDate = parseLocalDate(date);
  fromDate.setDate(fromDate.getDate() - 1);
  return formatDateText(fromDate);
}

export function getNextDate(date) {
  const fromDate = parseLocalDate(date);
  fromDate.setDate(fromDate.getDate() + 1);
  return formatDateText(fromDate);
}

export function getPreviousMonthFirstDate(date) {
  let inputDate = parseLocalDate(date);
  let year = inputDate.getFullYear();
  let month = inputDate.getMonth();
  let toDate = new Date(year, month - 1, 1);
  let lastDate = formatDateText(toDate);
  return lastDate;
}

export function getPreviousMonthLastDate(date) {
  let inputDate = parseLocalDate(date);
  let year = inputDate.getFullYear();
  let month = inputDate.getMonth();
  let totalDays = new Date(year, month, 0).getDate();
  let toDate = new Date(year, month - 1, totalDays);
  let lastDate = formatDateText(toDate);
  return lastDate;
}

export function getNextMonthFirstDate(date) {
  let inputDate = parseLocalDate(date);
  let year = inputDate.getFullYear();
  let month = inputDate.getMonth();
  let toDate = new Date(year, month + 1, 1);
  let lastDate = formatDateText(toDate);
  return lastDate;
}

export function getNextMonthLastDate(date) {
  let inputDate = parseLocalDate(date);
  let year = inputDate.getFullYear();
  let month = inputDate.getMonth();
  let toDate = new Date(year, month + 2, 0);
  let lastDate = formatDateText(toDate);
  return lastDate;
}

export function getPreviousYearFirstDate(date) {
  let inputDate = parseLocalDate(date);
  let year = inputDate.getFullYear();
  let toDate = new Date(year - 1, 0, 1);
  let lastDate = formatDateText(toDate);
  return lastDate;
}

export function getPreviousYearLastDate(date) {
  let inputDate = parseLocalDate(date);
  let year = inputDate.getFullYear();
  let toDate = new Date(year - 1, 11, 31);
  let lastDate = formatDateText(toDate);
  return lastDate;
}

export function getNextYearFirstDate(date) {
  let inputDate = parseLocalDate(date);
  let year = inputDate.getFullYear();
  let toDate = new Date(year + 1, 0, 1);
  let lastDate = formatDateText(toDate);
  return lastDate;
}

export function getNextYearLastDate(date) {
  let inputDate = parseLocalDate(date);
  let year = inputDate.getFullYear();
  let toDate = new Date(year + 1, 11, 31);
  let lastDate = formatDateText(toDate);
  return lastDate;
}

export function getPreviousWeekFirstDate(date) {
  const firstDayOfWeek = parseLocalDate(date);
  let dayOfWeek = firstDayOfWeek.getDay();
  firstDayOfWeek.setDate(firstDayOfWeek.getDate() - dayOfWeek - 7);
  return formatDateText(firstDayOfWeek);
}

export function getPreviousWeekLastDate(date) {
  const firstDayOfWeek = parseLocalDate(date);
  let dayOfWeek = firstDayOfWeek.getDay();
  firstDayOfWeek.setDate(firstDayOfWeek.getDate() - dayOfWeek - 7);
  const lastDayOfWeek = new Date(firstDayOfWeek);
  lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);
  return formatDateText(lastDayOfWeek);
}

export function getNextWeekFirstDate(date) {
  const firstDayOfWeek = parseLocalDate(date);
  let dayOfWeek = firstDayOfWeek.getDay();
  firstDayOfWeek.setDate(firstDayOfWeek.getDate() - dayOfWeek + 7);
  return formatDateText(firstDayOfWeek);
}

export function getNextWeekLastDate(date) {
  const firstDayOfWeek = parseLocalDate(date);
  let dayOfWeek = firstDayOfWeek.getDay();
  firstDayOfWeek.setDate(firstDayOfWeek.getDate() - dayOfWeek + 7);
  const lastDayOfWeek = new Date(firstDayOfWeek);
  lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);
  return formatDateText(lastDayOfWeek);
}

export function isEmiEnabled(date) {
  var selectedDate = moment(parseLocalDate(date));
  var currentDate = moment(new Date());
  return currentDate.isSameOrAfter(selectedDate, "day");
}

export function isDayAfter(fromDate, toDate) {
  var selectedFromDate = moment(parseLocalDate(fromDate));
  var selectedToDate = moment(parseLocalDate(toDate));
  return selectedFromDate.isSameOrAfter(selectedToDate, "day");
}

export function isDaySameBefore(fromDate, toDate) {
  var selectedFromDate = moment(parseLocalDate(fromDate));
  var selectedToDate = moment(parseLocalDate(toDate));
  return selectedFromDate.isSameOrBefore(selectedToDate, "day");
}

export function isDayBefore(fromDate, toDate) {
  var selectedFromDate = moment(parseLocalDate(fromDate));
  var selectedToDate = moment(parseLocalDate(toDate));
  return selectedFromDate.isBefore(selectedToDate, "day");
}

export function getDaysDiff(originDate, actualDate) {
  return moment(actualDate).diff(originDate, "days");
}

export function getCalenderModeVal(mode) {
  var val = "";
  if (mode === "DAILY") {
    val = "Date";
  } else if (mode === "WEEKLY") {
    val = "Week";
  } else if (mode === "MONTHLY") {
    val = "Month";
  } else if (mode === "YEARLY") {
    val = "Year";
  } else if (mode === "CUSTOM") {
    val = "";
  } else if (mode === "ALL") {
    val = "";
  }
  return val;
}

export const parseLocalDate = (date) => {
  if (!date) return new Date();
  if (date instanceof Date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }
  const dateStr = typeof date === "string" ? date.split("T")[0] : String(date);
  const [year, month, day] = dateStr.split("-").map(Number);
  return new Date(year, month - 1, day);
};
